/**
 * Format large numbers to shortened format (e.g., 1000 -> 1k, 1000000 -> 1M)
 */
export const numFormatter = (num: number, decimals: number = 0): string => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(decimals) + 'k';
  }
  return num.toString();
};

/**
 * Add leading zero to numbers less than 10
 */
export const addZero = (num: number): string => {
  return num < 10 ? '0' + num : num.toString();
};
